const userSelect = {
  name: "user-select",
  path: "user-select",
  title: "user-select",
  description: "Utilities for controlling the CSS user-select property.",
  value: {
    "user-select": {
      "select-none": "none",
      "select-text": "text",
      "select-all": "all",
      "select-auto": "auto"
    }
  },
  exampleData: [
    {
      title: "select-none, select-text, select-all, select-auto",
      description: "Control whether the user can select text:",
      moreDescription: "Try selecting the text in each box below.",
      parentClass: "grid md:grid-columns-2 gap-x-6 gap-y-10 !bg-none !border-0 !mt-10",
      example: {
        "element": "img",
        src: [
          {
            text: "Prevent selecting text in an element and its children",
            textClass: "select-none text-sm border border-color-gray-300 p-4 rounded text-color-gray-700 dark:text-color-gray-200 text-center",
            className: " p-4 border rounded bg-gray-50",
            containerClass: "relative"
          },
          {
            text: "Selecting text in an element and its children",
            textClass: "select-text text-sm border border-color-gray-300 p-4 rounded text-color-gray-700 dark:text-color-gray-200 text-center",
            className: " p-4 border rounded bg-gray-50",
            containerClass: "relative"
          },
          {
            text: "Automatically select all the text in an element when a user clicks",
            textClass: "select-all text-sm border border-color-gray-300 p-4 rounded text-color-gray-700 dark:text-color-gray-200 text-center",
            className: " p-4 border rounded bg-gray-50",
            containerClass: "relative"
          },
          {
            text: "Default browser behavior for selecting text",
            textClass: "select-auto text-sm border border-color-gray-300 p-4 rounded text-color-gray-700 dark:text-color-gray-200 text-center",
            className: " p-4 border rounded bg-gray-50",
            containerClass: "relative"
          },
        ],
        code: `<div class="select-none ...">select-none: User cannot select this text.</div>
<div class="select-text ...">select-text: User can select this text.</div>
<div class="select-all ...">select-all: Selecting any part selects all.</div>
<div class="select-auto ...">select-auto: Default browser behavior.</div>`
      }
    }
  ]
};

export default userSelect;